<template> <!-- OK -->
    <div>
      <NavBar/>
      <div class="pagina-jogos-container">
        <div class="stage-selector">
          <select v-model="selectedStageId" @change="fetchGames">
            <option v-for="stage in stages" :key="stage.id" :value="stage.id">
              {{ stage.name }}
            </option>
          </select>
        </div>
        <GamesTable
          :games="games"
        />
      </div>
    </div>
  </template>

  <script>
  import NavBar from '../components/NavBar.vue';
  import GamesTable from '../components/GamesTable.vue';
  import stageService from '../services/stageService';
  import gameService from "@/services/gameService";

  export default {
    name: 'Jogos',
    components: {
      NavBar,
      GamesTable
    },
    data(){
      return{
        stages: [],
        selectedStageId: null,
        games: []
      };
    },
    async created(){
      await this.loadStages();
    },
    methods: {
      async loadStages(){
        try{
          const response = await stageService.getAllStages();
          this.stages = response.data;
          if(this.stages.length > 0){
            this.selectedStageId = this.stages[this.stages.length - 1].id;
            await this.fetchGames();
          }
        } catch(error){
          console.error('Erro ao buscar as etapas:', error);
        }
      },
      async fetchGames(){
        if(!this.selectedStageId) return;

        try{
          const response = await gameService.getGamesForStage(this.selectedStageId);
          this.games = response.data.filter(game => game.status !== 'Não Realizado');
        }catch (error){
          console.error('Erro ao buscar os jogos:', error);
        }
      }
    }
  };
  </script>

  <style scoped>

  .pagina-jogos-container{
    background-color: #003366;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .stage-selector{
    text-align: center;
    margin: 2rem 0;
  }

  .stage-selector select{
    padding: 0.5rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #CCC;
  }

  @media (max-width: 425px){
    .pagina-jogos-container{
      width: 100%;
      padding: 0.5rem;
    }

    .stage-selector select{
      width: 100%;
    }
  }

  @media (min-width: 426px) and (max-width: 768px){
    .pagina-jogos-container{
      width: 100%;
      padding: 1rem;
    }
  }

  </style>
